import { lazy, Suspense } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import "./App.css";
import HomePage from "./Pages/HomePage/HomePage";
import VacanciesPage from "./Pages/VacanciesPage/VacanciesPage";
import VacanciesItemPage from "./Pages/VacanciesItemPage/VacanciesItemPage";
import BusinessPage from "./Pages/BusinessPage/BusinessPage";
import WhoisPage from "./Pages/WhoisPage/WhoisPage";
import SksPage from "./Pages/SksPage/SksPage";
import NewsPage from "./Pages/NewsPage/NewsPage";
import NewsItemPage from "./Pages/NewsItemPage/NewsItemPage";
import RouterPage from "./Pages/RouterPage/RouterPage";
import HostingPage from "./Pages/HostingPage/HostingPage";
import DirectumPage from "./Pages/DirectumPage/DirectumPage";
import VideoPage from "./Pages/VideoPage/VideoPage";
import PrivacyPolicy from "./Pages/PrivacyPolicy/PrivacyPolicy";
import AdminLoginPage from "./Pages/AdminPages/AdminLoginPage/AdminLoginPage";
import AuthGuard from "./Components/Admin/AuthGuard/AuthGuard";
import NotNetwork from "./Components/NotNetwork/NotNetwork";
import OfertaPage from "./Pages/oferta/oferta";
// Промо-страница /world-cup-2026 удалена (наследие): виджет ЧМ живёт на
// главной (#worldcup). Остаётся только страница правил акции.
import WorldCupRulesPage from "./Pages/WorldCupRules/WorldCupRules";
import ScrollToTop from "./Components/General/ScrollToTop/ScrollToTop";
import { ThemeProvider } from "./theme/ThemeProvider";
import AnalyticsRoutes from "./analytics/AnalyticsRoutes";
import CookieNotice from "./UI/CookieNotice/CookieNotice";

// Страницы админки — отдельным чанком: их CSS не должен попадать в бандл
// публичного сайта (там живут дубли глобальных имён классов) и не грузится
// у обычного посетителя вовсе.
const AdminHomePage = lazy(() => import("./Pages/AdminPages/AdminHomePage/AdminHomePage"));
const AdminHistoryPage = lazy(() => import("./Pages/AdminPages/AdminHistoryPage/AdminHistoryPage"));
const AdminTarifsPage = lazy(() => import("./Pages/AdminPages/AdminTarifsPage/AdminTarifsPage"));
const AdminServicesPage = lazy(() => import("./Pages/AdminPages/AdminServicesPage/AdminServicesPage"));

function App() {
  // Captive-портал: nets.tj/?l=<ls> → редирект на портал с этим ls.
  // Проверяем ДО роутинга, чтобы страница не мелькнула; replace — без
  // записи в историю (кнопка «назад» не вернёт на пустой редирект).
  const captiveLs = new URLSearchParams(window.location.search).get("l");
  if (captiveLs) {
    window.location.replace(
      "https://captive.nets.tj/?ls=" + encodeURIComponent(captiveLs)
    );
    return null;
  }

  return (
    <BrowserRouter>
      <ThemeProvider>
      <AnalyticsRoutes />
      <CookieNotice />
      <ScrollToTop />
      <Routes>
        <Route element={<HomePage />} path="/" />
        <Route element={<HomePage />} path="/cash" />
        <Route path="*" element={<Navigate to="/" replace />} />
        <Route element={<VacanciesPage />} path="/vacancies" />
        <Route element={<VacanciesItemPage />} path="/vacanciesItem/:id" />
        <Route element={<BusinessPage />} path="/business" />
        <Route element={<WhoisPage />} path="/whois" />
        <Route element={<SksPage />} path="/system" />
        <Route element={<NewsPage />} path="/news" />
        <Route element={<NewsItemPage />} path="/newsItem/:id" />
        <Route element={<RouterPage />} path="/router" />
        <Route element={<HostingPage />} path="/hosting" />
        <Route element={<DirectumPage />} path="/directum" />
        <Route element={<VideoPage />} path="/video" />
        <Route element={<PrivacyPolicy />} path="/privacy_policy" />
        <Route element={<AdminLoginPage />} path="/login" />
        <Route element={<NotNetwork />} path="/notNetwork" />
        <Route element={<OfertaPage />} path="/oferta" />
        {/* Старая промо-страница удалена → редирект на главную (виджет #worldcup) */}
        <Route path="/world-cup-2026" element={<Navigate to="/" replace />} />
        <Route element={<WorldCupRulesPage />} path="/world-cup-2026/rules" />
        <Route
          element={
            <Suspense fallback={null}>
              <AuthGuard />
            </Suspense>
          }
        >
          <Route element={<AdminHomePage />} path="/adminHome" />
          <Route element={<AdminHistoryPage />} path="/adminHistory" />
          <Route element={<AdminTarifsPage />} path="/adminTarifs" />
          <Route element={<AdminServicesPage />} path="/adminServices" />
        </Route>
      </Routes>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
